import { render, staticRenderFns } from "./JuniorHighSchoolChineseCourse.vue?vue&type=template&id=8a1c20ee&scoped=true&"
import script from "./JuniorHighSchoolChineseCourse.vue?vue&type=script&lang=js&"
export * from "./JuniorHighSchoolChineseCourse.vue?vue&type=script&lang=js&"
import style0 from "./JuniorHighSchoolChineseCourse.vue?vue&type=style&index=0&id=8a1c20ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1c20ee",
  null
  
)

export default component.exports